module.exports = __webpack_public_path__ + "img/3.5300a4c9.png";